document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll('.tabs').forEach(tabContainer => {

    const titles = tabContainer.querySelectorAll('.tab-title');
    const contents = tabContainer.querySelectorAll('.tab-content');

    titles.forEach(title => {
      title.addEventListener('click', () => {

        // Nur innerhalb dieses Tab-Containers arbeiten
        titles.forEach(t => t.classList.remove('active'));
        contents.forEach(c => c.classList.remove('active'));

        title.classList.add('active');
        tabContainer.querySelector('#' + title.dataset.tab).classList.add('active');
      });
    });

    // Ersten Tab automatisch aktivieren
    if (titles.length > 0 && contents.length > 0) {
      titles[0].classList.add('active');
      contents[0].classList.add('active');
    }

  });
});

(() => {
  if (!/^en(?:-|$)/i.test(document.documentElement.lang) || window.__spottleSmsChannelLabelReady) return;
  window.__spottleSmsChannelLabelReady = true;

  const rootSelector = '#restock-rocket';
  const inputSelector = '#restock-rocket #form-Channels-Container input[name="notification-channel"][value="sms"]';

  function updateLabel() {
    document.querySelectorAll(inputSelector).forEach(input => {
      const label = input.closest('.form-Channel-Label')?.querySelector('.form-Channel-Name');
      if (label && label.textContent !== 'SMS') label.textContent = 'SMS';
    });
  }

  function initialize() {
    new MutationObserver(mutations => {
      if (mutations.some(mutation => {
        const target = mutation.target.nodeType === Node.ELEMENT_NODE ? mutation.target : mutation.target.parentElement;
        if (target?.closest(rootSelector)) return true;
        return Array.from(mutation.addedNodes).some(node => node.nodeType === Node.ELEMENT_NODE &&
          (node.matches(rootSelector) || node.querySelector(rootSelector)));
      })) updateLabel();
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
    updateLabel();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
